/*=========================================================================================
  File Name: modulePrescripteurState.js
  Description: state of module Prescripteur
  ----------------------------------------------------------------------------------------
==========================================================================================*/

export default {
  prescripteurs: []
}
